export default "__VITE_ASSET__qXQhIOFz__"